import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useState, useEffect } from 'react';


function BubbleChoice({ choiceText, explosion, clicked, onClickedOption, wrong, onExplodedButton }) {
    const [scale, setScale] = useState(1);
    const [isExploded, setIsExploded] = useState(false);
    
    const intervalMS = 1000;
    const maxScale = 1.2;
    const growingStep = 0.5;
    
    useEffect(() => {
        if (explosion && !isExploded) {
            growButton();
        }
    }, [explosion]);
    
    useEffect(() => {
        if (scale >= maxScale && !isExploded) {
            setIsExploded(true);
            onExplodedButton();
        }
    }, [scale, isExploded, onExplodedButton]);
    
    function handleClick() {
        onClickedOption();
    }
    
    function growButton() {
        const growInterval = setInterval(() => {
            setScale((prevScale) => {
                if (prevScale >= maxScale) {
                    clearInterval(growInterval);
                    return maxScale;
                }
                return prevScale + growingStep;
            });
        }, intervalMS);
    }
    
    return (
        <div
            className="baseElementsBubbleChoiceDiv"
            style={{
                transform: `scale(${scale})`,
                transition: 'transform 0.3s ease'
            }}
        >
            <button
                className={isExploded ? "correctBubbleButton" : wrong ? "wrongBubbleButton" : clicked ? "clickedBubbleButton" : "bubbleButton"}
                onClick={handleClick}
            >
                {choiceText}
            </button>
        </div>
    );
}

export default BubbleChoice;

